import React, { Component } from "react";
import { connect } from "react-redux";
import { Translation } from "react-i18next";
import { setGAEvent } from "../../function/setGAEvent";

class PdtNextBtnWrap extends Component {
  render() {
    const { myBagData, getMyBagSuccessfully } = this.props;

    return (
      <>
        {myBagData.cartItems ? (
          getMyBagSuccessfully && myBagData.cartItems.length > 0 ? (
            <button
              className="blockBtn goSectBtn"
              data-gosect=".checkout_deliver"
              onClick={() => {
                setGAEvent("begin_checkout", myBagData);
              }}
            >
              <Translation>{t => <>{t(`checkout.next`)}</>}</Translation>
            </button>
          ) : (
            <button className="blockBtn" data-gosect=".checkout_deliver">
              <Translation>{t => <>{t(`checkout.next`)}</>}</Translation>
            </button>
          )
        ) : null}
      </>
    );
  }
}

const mapStateToProps = state => ({
  getMyBagSuccessfully: state.myBag.getMyBagSuccessfully,
  myBagData: state.myBag.myBagData
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PdtNextBtnWrap);
